import intlTelInput from "intl-tel-input/intlTelInputWithUtils"
import fr from "intl-tel-input/i18n/fr";
import es from "intl-tel-input/i18n/es";
import de from "intl-tel-input/i18n/de";
import pt from "intl-tel-input/i18n/pt";
import en from "intl-tel-input/i18n/en";

export default class IntTelephoneType {

    constructor()
    {
        this.featuredContries = ['gb', 'ie', 'fr', 'pt', 'de', 'nl', 'be', 'ch', 'es', 'ad'];
        this.defaultCountries = {
            1: 'es',
            2: 'es',
            3: 'gb',
            4: 'fr',
            5: 'pt',
            6: 'de',
            7: 'it'
        };
        this.defaultLanguage = {
            'es': es,
            'ca': es,
            'en': en,
            'fr': fr,
            'pt': pt,
            'de': de,
            'it': en
        };
        this.intlTelInputs = new Map();
        this.eventDelegation();
    }

    eventDelegation() {
        this.setInitializeIntTelType();
        this.initializeCopyTelToInputHidden();
        this.setFeaturedPrefix();
    };
    
    setInitializeIntTelType() {
        $('[data-type="int-tel"]').each((index, intlTelInputElement) => {
            this.initializeInput(intlTelInputElement);
        });
    };

    copyTelToInputHidden(intlTelInputElement) {
        const inputNumTarget = intlTelInputElement.getAttribute('data-target');
        if (inputNumTarget) {
            this._copyFullTel(intlTelInputElement, inputNumTarget);
            return;
        }

        // Copy dial code to input dial hidden
        const inputDialTarget = intlTelInputElement.getAttribute('data-dial-target');
        if (inputDialTarget) {
            this._copyDialCode(inputDialTarget);
        }
    }

    initializeCopyTelToInputHidden() {
        $("body").on("blur", "[data-type='int-tel']", (intlTelInputElement) => {
            // Copy full tel to input hidden
            this.copyTelToInputHidden(intlTelInputElement.currentTarget);
        });
    };

    _copyFullTel(intlTelInputElement, inputNumTarget) {
        let phoneWithPrefix = Array.from(this.intlTelInputs.values())[parseInt(inputNumTarget)].getNumber();
        $('#' + $(intlTelInputElement).attr('name') + '[data-target='+ inputNumTarget +']').val(phoneWithPrefix.replace('+', ''));
    }

    _copyDialCode(inputDialTarget) {
        const dialCode = Array.from(this.intlTelInputs.values())[0].selectedDialCode;
        if (dialCode && dialCode.textContent) {
            $('#'+inputDialTarget).val(dialCode.textContent.replace('+', ''));
        }
    }

    getClientCountry() {
        let countryElem = $("input[name=clientcountrycode]").filter((index, elem) => $(elem).val());
        let country = countryElem.val();
        if (country !== undefined) {
            return country.toLowerCase();
        } else {
            let languageElem = $("input[name=idioma]").filter((index, elem) => $(elem).val());
            let language = parseInt(languageElem.val());
            if (language) {
                return this.defaultCountries[language];
            }
        }
        return this.defaultCountries[1];
    }

    setFeaturedPrefix() {
        const countries = intlTelInput.getCountryData();

        Array.from(this.intlTelInputs.values()).forEach( intlTelInput => {
            const prefix = intlTelInput.selectedCountryData.dialCode;
            if (!prefix) {
                return;
            }

            let inputCountry = countries.find(country => country.dialCode === prefix && this.featuredContries.includes(country.iso2));

            if (!inputCountry) {
                inputCountry = countries.find(country => country.dialCode === prefix);
            }

            if (inputCountry) {
                intlTelInput.setCountry(inputCountry.iso2)
            }

            //Copy dial code to input dial hidden
            const inputDialTarget = intlTelInput.telInput.dataset.dialTarget
            if (inputDialTarget) {
                this._copyDialCode(inputDialTarget);
            }
        })
    }

    updateLabelAndDivider(intlTelInputElement) {
        const label = document.querySelector('label[for=' + intlTelInputElement.id + ']');
        const input = document.querySelector('input[name="' + intlTelInputElement.name + '"]');
        let inputDivider = null

        if (label) {
            inputDivider = label.closest('.vpt-input-divider')
        }
        
        if (inputDivider) {
            inputDivider.style.setProperty("--divider-offset", `${parseInt(intlTelInputElement.style.paddingLeft) - 5}px`);
        }
        
        if (label) {
            label.style.left = intlTelInputElement.style.paddingLeft;
            intlTelInputElement.parentNode.appendChild(label);
        }
        if (input) {
            input.style.paddingLeft = intlTelInputElement.style.paddingLeft;
        }
    }

    getInstance(intlTelInputElement) {
        return this.intlTelInputs.get(intlTelInputElement);
    }

    initializeInput(intlTelInputElement) {
        const intlTelFullscreenDropdown = intlTelInputElement.dataset.intltelFullscreenDropdown
        const config = {
            separateDialCode: true,
            initialCountry: this.getClientCountry(),
            responsiveDropdown: true,
            i18n: this.defaultLanguage[myApp.config.locale],
            formatAsYouType: true,
            formatOnDisplay: true,
            countryOrder: this.featuredContries,
            nationalMode: true,
            strictMode: true
        }

        if (intlTelFullscreenDropdown) {
            config.useFullscreenPopup = true;
        }

        const instance = intlTelInput(intlTelInputElement, config)
        this.intlTelInputs.set(intlTelInputElement, instance);

        if (intlTelInputElement.id) {
            this.updateLabelAndDivider(intlTelInputElement);

            intlTelInputElement.addEventListener('countrychange', (e) => {
                this.updateLabelAndDivider(intlTelInputElement);
            });

        }
        return instance;
    }
};

